var map = {
	"./Udemy.webp": 2195,
	"./alura.png": 8230,
	"./bradesco.ico": 9536,
	"./fundacao-bradesco.png": 731,
	"./prime.png": 5613,
	"./proa.png": 9827,
	"./tc.svg": 7243
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3429;